// src/Components/ReCaptcha/index.jsx
import React from "react";
import clsx from "clsx";
import Styles from "./index.module.scss";

const ReCaptcha = ({
  version,
  isDefaultV3,
  reCaptchaV2,
  recaptchaLoading,
  recaptchaError,
  isLoadReCaptChaV3,
}) => {
  if (version !== "2" && isDefaultV3) {
    return isLoadReCaptChaV3 ? (
      <div className={clsx(Styles.verifying)}>
        <p>Đang xác minh . . .</p>
      </div>
    ) : null;
  }

  return (
    <div className={clsx(Styles.recaptchaContainer)}>
      <div
        id="recaptcha"
        className={clsx(Styles.recaptcha)}
        ref={reCaptchaV2}
      ></div>

      {recaptchaLoading && (
        <div className={clsx(Styles.recaptchaLoading)}>
          <p>Đang tải reCAPTCHA...</p>
        </div>
      )}

      {recaptchaError && (
        <div className={clsx(Styles.recaptchaError)}>
          <p>{recaptchaError}</p>
          <button
            type="button"
            className={clsx(Styles.reloadBtn)}
            onClick={() => window.location.reload()}
          >
            Tải lại
          </button>
        </div>
      )}
    </div>
  );
};

export default ReCaptcha;
